export function RadiationIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <circle cx="10" cy="10" r="2" stroke="currentColor" strokeWidth="1.4" />
      <path
        d="M10 8C10 8 10.7 4.5 13.5 3C13.5 3 15.8 5 14.5 8.5"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7 10.95C11.7 10.95 15 12.2 16.2 15C16.2 15 13.5 16.5 10.5 14.5"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.3 10.95C8.3 10.95 5 12.2 3.8 15C3.8 15 6.5 16.5 9.5 14.5"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 8C10 8 9.3 4.5 6.5 3C6.5 3 4.2 5 5.5 8.5"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 10C12 10 15.3 9.3 17.2 6.8C17.2 6.8 15 4.2 11.7 5.8"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 10C8 10 4.7 9.3 2.8 6.8C2.8 6.8 5 4.2 8.3 5.8"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
